import React, { useState } from "react";

// CSS
import "./../../../assets/css/purchase/datatable.css";

// Utils
import { formatCurrency } from "../../../utils/SamuiUtils";
import { formatDate } from "../../../utils/DateUtils";

const ReportsTable = ({
  currentItems,
  currentPage,
  handlePageChange,
  dataMasterList,
  itemsPerPage,
  fieldMappings
}) => {
  // State สำหรับเก็บ ID แถวที่เลือก
  const [selectedRow, setSelectedRow] = useState(null);

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(dataMasterList.length / itemsPerPage);
    const pages = [];
    const maxVisiblePages = 5;
    const range = 2;

    if (totalPages > maxVisiblePages) {

      pages.push(
        <li
          key={1}
          className={`paginate_button page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <a href="#" className="page-link" onClick={() => handlePageChange(1)}>
            1
          </a>
        </li>
      );

      if (currentPage - range > 2) {
        pages.push(
          <li key="ellipsis-start" className="paginate_button page-item">
            <a href="#" className="page-link">...</a>
          </li>
        );
      }

      for (let i = Math.max(currentPage - range, 2); i <= Math.min(currentPage + range, totalPages - 1); i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""}`}
          >
            <a href="#" className="page-link" onClick={() => handlePageChange(i)}>
              {i}
            </a>
          </li>
        );
      }

      if (currentPage + range < totalPages - 1) {
        pages.push(
          <li key="ellipsis-end" className="paginate_button page-item">
            <a href="#" className="page-link">...</a>
          </li>
        );
      }

      pages.push(
        <li
          key={totalPages}
          className={`paginate_button page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <a href="#" className="page-link" onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </a>
        </li>
      );
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`paginate_button page-item ${currentPage === i ? "active" : ""}`}
          >
            <a href="#" className="page-link" onClick={() => handlePageChange(i)}>
              {i}
            </a>
          </li>
        );
      }
    }

    return pages;
  };

  return (
    <div className="col-md-12 mt-4">
      <div className="card">
        <div className="card-header">
          <h4>ผลการค้นหา</h4>
        </div>
        <div className="card-body">
          {/* DataTable */}
          <div
            className="table-responsive"
            style={{ maxHeight: "550px", overflowY: "auto" }}
          >
            <table
              id="basic-datatables"
              className="table table-striped table-hover"
            >
              <thead className="thead-dark">
                {/* 1. รายงานยอดซื้อ / ขายประจำวัน */}
                {window.location.pathname === "/sales-report" && (
                  <tr>
                    <th className="text-center">
                      วันที่่เอกสาร
                    </th>
                    <th className="text-center">
                      เลขที่เอกสาร
                    </th>
                    <th className="text-center">
                      สร้างจาก
                    </th>
                    <th className="text-center">
                      สถานะการชำระเงิน
                    </th>
                    <th className="text-center">
                      ช่องทางการชำระเงิน
                    </th>
                    <th className="text-center">
                      รหัสลูกค้า
                    </th>
                    <th className="text-center">
                      ชื่อลูกค้า
                    </th>
                    <th className="text-center">
                      ยอดขาย
                    </th>
                  </tr>
                )}

                {/* 2.1 รายงาน inventory movement (แยกตามแผนก/คลัง)  */}
                {window.location.pathname === "/inventory-movement-report" && (
                  <tr>
                    <th className="text-center">
                      วันที่สต๊อก
                    </th>
                    <th className="text-center">
                      รหัสสินค้า
                    </th>
                    <th className="text-center">
                      ชื่อสินค้า
                    </th>
                    <th className="text-center">
                      ประเภท
                    </th>
                    <th className="text-center">
                      จำนวน
                    </th>
                    <th className="text-center">
                      เลขเอกสาร
                    </th>
                    <th className="text-center">
                      เอกสารอ้างอิง
                    </th>
                    <th className="text-center">
                      หมายเหตุ
                    </th>
                  </tr>
                )}

                {/* 2.2 รายงานสินค้าคงเหลือประจำวัน แยกตามคลัง / แยกตามสินค้า  */}
                {window.location.pathname === "/stock-balance-report" && (
                  <tr>
                    <th className="text-center">
                      รหัสสินค้า
                    </th>
                    <th className="text-center">
                      ชื่อสินค้า
                    </th>
                    <th className="text-center">
                      จำนวน
                    </th>
                    <th className="text-center">
                      หน่วย
                    </th>
                  </tr>
                )}

                {/* 3. รายงานยืมลังประจำวัน */}
                {window.location.pathname === "/loan-crate-report" && (
                  <tr>
                    <th className="text-center">
                      เลขที่ใบยืมสินค้า
                    </th>
                    <th className="text-center">
                      รหัสลูกค้า
                    </th>
                    <th className="text-center">
                      ชื่อลูกค้า
                    </th>
                    <th className="text-center">
                      รหัสสินค้า
                    </th>
                    <th className="text-center">
                      ชื่อสินค้า
                    </th>
                    <th className="text-center">
                      จำนวน
                    </th>
                    <th className="text-center">
                      หน่วย
                    </th>
                  </tr>
                )}

                {/* 4. รายงานมัดจำประจำวัน */}
                {window.location.pathname === "/deposit-report" && (
                  <tr>
                    <th className="text-center">
                      วันที่เอกสาร
                    </th>
                    <th className="text-center">
                      เลขที่เอกสาร
                    </th>
                    <th className="text-center">
                      สถานะ
                    </th>
                    <th className="text-center">
                      รหัสลูกค้า
                    </th>
                    <th className="text-center">
                      ชื่อลูกค้า
                    </th>
                    <th className="text-center">
                      จำนวนเงิน
                    </th>
                  </tr>
                )}

                {/* 5. รายงานลูกค้ายืมลัง แล้วไม่สั่งเกินสัปดาห์ */}
                {window.location.pathname === "/overdue-loan-crate-report" && (
                  <tr>
                    <th className="text-center">
                      รหัสลูกค้า
                    </th>
                    <th className="text-center">
                      ชื่อลูกค้า
                    </th>
                    <th className="text-center">
                      วันที่สั่งล่าสุด
                    </th>
                    <th className="text-center">
                      จำนวนลังที่ยืม
                    </th>
                    <th className="text-center">
                      รหัสลังที่ยืม
                    </th>
                  </tr>
                )}

                {/* 5. รายงานลูกค้ายืมลัง แล้วไม่สั่งเกินสัปดาห์ */}
                {window.location.pathname === "/overdue-loan-crate-report" && (
                  <tr>
                    <th className="text-center">
                      รหัสลูกค้า
                    </th>
                    <th className="text-center">
                      ชื่อลูกค้า
                    </th>
                    <th className="text-center">
                      วันที่สั่งล่าสุด
                    </th>
                    <th className="text-center">
                      จำนวนลังที่ยืม
                    </th>
                    <th className="text-center">
                      รหัสลังที่ยืม
                    </th>
                  </tr>
                )}

                {/* 6.1 รายงานลูกหนี้ รายวัน */}
                {window.location.pathname === "/receivables-report" && (
                  <tr>
                    <th className="text-center">
                      วันที่เอกสาร
                    </th>
                    <th className="text-center">
                      สายรถ
                    </th>
                    <th className="text-center">
                      เลขที่เอกสาร
                    </th>
                    <th className="text-center">
                      รหัสลูกค้า
                    </th>
                    <th className="text-center">
                      ชื่อลูกค้า
                    </th>
                    <th className="text-center">
                      จำนวน
                    </th>
                    <th className="text-center">
                      จำนวนเงิน
                    </th>
                  </tr>
                )}

                {/* 6.2 รายงานเจ้าหนี้ รายวัน */}
                {window.location.pathname === "/payables-report" && (
                  <tr>
                    <th className="text-center">
                      เลขใบ PO
                    </th>
                    <th className="text-center">
                      สถานะเอกสาร
                    </th>
                    <th className="text-center">
                      รหัสเจ้าหนี้
                    </th>
                    <th className="text-center">
                      ชื่อเจ้าหนี้
                    </th>
                    <th className="text-center">
                      จำนวน
                    </th>
                    <th className="text-center">
                      จำนวนเงิน
                    </th>
                  </tr>
                )}

                {/* 6.3 รายงานนำส่งรายได้ */}
                {window.location.pathname === "/vansale-report" && (
                  <>
                    <tr>
                      <th rowSpan={2} className="text-center">
                        เลขที่ใบขาย
                      </th>
                      <th rowSpan={2} className="text-center">
                        รายชื่อลูกค้า
                      </th>
                      <th colSpan={5} className="text-center">
                        รายการสินค้า IDRINK
                      </th>
                      <th colSpan={3} className="text-center">
                        ยอดขาย
                      </th>
                      <th colSpan={5} className="text-center">
                        การชำระ
                      </th>
                      <th rowSpan={2} className="text-center">
                        ผู้จัดส่ง
                      </th>
                      <th rowSpan={2} className="text-center">
                        ช่วงส่ง
                      </th>
                    </tr>
                    <tr>
                      <th className="text-center">
                        oem
                      </th>
                      <th className="text-center">
                        350ml
                      </th>
                      <th className="text-center">
                        600ml
                      </th>
                      <th className="text-center">
                        1500ml
                      </th>
                      <th className="text-center">
                        น้ำถัง
                      </th>
                      <th className="text-center">
                        ยอดขาย
                      </th>
                      <th className="text-center">
                        Vat
                      </th>
                      <th className="text-center">
                        รวมยอดทั้งหมด
                      </th>
                      <th className="text-center">
                        เงินสด
                      </th>
                      <th className="text-center">
                        โอน
                      </th>
                      <th className="text-center">
                        เครดิต
                      </th>
                      <th className="text-center">
                        เช็ค
                      </th>
                      <th className="text-center">
                        ค้างจ่าย
                      </th>
                    </tr>
                  </>
                )}
              </thead>
              <tbody>
                {/* 1. รายงานยอดซื้อ / ขายประจำวัน */}
                {window.location.pathname === "/sales-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = data[fieldMappings.docNo] || index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* วันที่่เอกสาร */}
                          <td className="text-center">
                            {data[fieldMappings.docDate]
                              ? formatDate(data[fieldMappings.docDate])
                              : "-"}
                          </td>

                          {/* เลขที่เอกสาร */}
                          <td className="text-center">
                            {data[fieldMappings.docNo] || "-"}
                          </td>

                          {/* สร้างจาก */}
                          <td className="text-center">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: (data[fieldMappings.docIsPickingList] === 0
                                  || data[fieldMappings.docIsPickingList] === null) ? '#EAA300' : '#13A10E',
                                color: 'white',
                                width: '100%'
                              }}
                            >
                              {(data[fieldMappings.docIsPickingList] === 0
                                || data[fieldMappings.docIsPickingList] === null) ? 'ใบขาย' : 'VANSALE'}
                            </button>
                          </td>

                          {/* สถานะการชำระเงิน */}
                          <td className="text-center">
                            {data[fieldMappings.statusPaidName] ? (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor:
                                    data[fieldMappings.statusPaidColour],
                                  color: "white",
                                  width: "100%",
                                }}
                              >
                                {data[fieldMappings.statusPaidName]}
                              </button>
                            ) : (
                              <center>
                                <p>-</p>
                              </center>
                            )}
                          </td>

                          {/* ช่องทางการชำระเงิน */}
                          <td className="text-center">
                            {data[fieldMappings.payTypeName] ? (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor: data[fieldMappings.payTypeColor],
                                  color: "white",
                                  width: "100%",
                                }}
                              >
                                {data[fieldMappings.payTypeName]}
                              </button>
                            ) : (
                              <center>
                                <p>-</p>
                              </center>
                            )}
                          </td>

                          {/* รหัสลูกค้า */}
                          <td className="text-center">
                            {data[fieldMappings.arCode] || "-"}
                          </td>

                          {/* ชื่อลูกค้า */}
                          <td className="text-left">
                            {data[fieldMappings.arName] || "-"}
                          </td>

                          {/* ยอดขาย */}
                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.netTotal] || 0.0)}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}

                {/* 2.1 รายงาน inventory movement (แยกตามแผนก/คลัง)  */}
                {window.location.pathname === "/inventory-movement-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = data[fieldMappings.docNo] || index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* วันที่สต๊อก */}
                          <td className="text-center">
                            {data[fieldMappings.stcDate]
                              ? formatDate(data[fieldMappings.stcDate])
                              : "-"}
                          </td>

                          {/* รหัสสินค้า */}
                          <td className="text-center">
                            {data[fieldMappings.itemCode] || "-"}
                          </td>

                          {/* รหัสสินค้า */}
                          <td className="text-left">
                            {data[fieldMappings.itemName] || "-"}
                          </td>

                          {/* ประเภท */}
                          <td className="text-center">
                            {data[fieldMappings.docType] || "-"}
                          </td>

                          {/* จำนวน */}
                          <td className="text-center">
                            {data[fieldMappings.stcQty] || "-"}
                          </td>

                          {/* เลขเอกสาร */}
                          <td className="text-center">
                            {data[fieldMappings.docNo] || "-"}
                          </td>

                          {/* เอกสารอ้างอิง */}
                          <td className="text-center">
                            {data[fieldMappings.docNoRef] || "-"}
                          </td>

                          {/* หมายเหตุ */}
                          <td className="text-left">
                            {data[fieldMappings.stcRemark] || "-"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}

                {/* 2.1 รายงาน inventory movement (แยกตามแผนก/คลัง)  */}
                {window.location.pathname === "/stock-balance-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* รหัสสินค้า */}
                          <td className="text-center">
                            {data[fieldMappings.itemCode] || "-"}
                          </td>

                          {/* รหัสสินค้า */}
                          <td className="text-left">
                            {data[fieldMappings.itemName] || "-"}
                          </td>

                          {/* จำนวน */}
                          <td className="text-center">
                            {data[fieldMappings.itemOnHand] || "-"}
                          </td>

                          {/* หน่วย */}
                          <td className="text-center">
                            {data[fieldMappings.itemUnit] || "-"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}

                {/* 3. รายงานยืมลังประจำวัน */}
                {window.location.pathname === "/loan-crate-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* เลขที่ใบยืมสินค้า */}
                          <td className="text-center">
                            {data[fieldMappings.whDocNo] || "-"}
                          </td>

                          {/* รหัสลูกค้า */}
                          <td className="text-center">
                            {data[fieldMappings.tWhCode] || "-"}
                          </td>

                          {/* ชื่อลูกค้า */}
                          <td className="text-left">
                            {data[fieldMappings.tWhName] || "-"}
                          </td>

                          {/* รหัสสินค้า */}
                          <td className="text-center">
                            {data[fieldMappings.itemCode] || "-"}
                          </td>

                          {/* ชื่อสินค้า */}
                          <td className="text-left">
                            {data[fieldMappings.itemName] || "-"}
                          </td>

                          {/* จำนวน */}
                          <td className="text-center">
                            {data[fieldMappings.itemQty] || "-"}
                          </td>

                          {/* หน่วย */}
                          <td className="text-center">
                            {data[fieldMappings.itemUnit] || "-"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}

                {/* 4. รายงานมัดจำประจำวัน */}
                {window.location.pathname === "/deposit-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = data[fieldMappings.docNo] || index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* วันที่่เอกสาร */}
                          <td className="text-center">
                            {data[fieldMappings.docDate]
                              ? formatDate(data[fieldMappings.docDate])
                              : "-"}
                          </td>

                          {/* เลขที่เอกสาร */}
                          <td className="text-center">
                            {data[fieldMappings.docNo] || "-"}
                          </td>

                          {/* สถานะ */}
                          <td className="text-center">
                            {data[fieldMappings.docStatusName] ? (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor:
                                    data[fieldMappings.docStatusColor],
                                  color: "white",
                                  width: "100%",
                                }}
                              >
                                {data[fieldMappings.docStatusName]}
                              </button>
                            ) : (
                              <center>
                                <p>-</p>
                              </center>
                            )}
                          </td>

                          {/* รหัสลูกค้า */}
                          <td className="text-center">
                            {data[fieldMappings.arCode] || "-"}
                          </td>

                          {/* ชื่อลูกค้า */}
                          <td className="text-left">
                            {data[fieldMappings.arName] || "-"}
                          </td>

                          {/* ยอดขาย */}
                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.netTotal] || 0.0)}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}

                {/* 6.1 รายงานลูกหนี้ รายวัน */}
                {window.location.pathname === "/receivables-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = data[fieldMappings.docNo] || index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* วันที่่เอกสาร */}
                          <td className="text-center">
                            {data[fieldMappings.docDate]
                              ? formatDate(data[fieldMappings.docDate])
                              : "-"}
                          </td>

                          {/* สายรถ */}
                          <td className="text-left">
                            {data[fieldMappings.dLLineName] || "-"}
                          </td>

                          {/* เลขที่เอกสาร */}
                          <td className="text-center">
                            {data[fieldMappings.docNo] || "-"}
                          </td>

                          {/* รหัสลูกค้า */}
                          <td className="text-center">
                            {data[fieldMappings.arCode] || "-"}
                          </td>

                          {/* ชื่อลูกค้า */}
                          <td className="text-left">
                            {data[fieldMappings.arName] || "-"}
                          </td>

                          {/* จำนวน */}
                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.itemQty] || 0.0)}
                          </td>

                          {/* จำนวนเงิน */}
                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.netTotal] || 0.0)}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}

                {/* 6.2 รายงานเจ้าหนี้ รายวัน */}
                {window.location.pathname === "/payables-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = data[fieldMappings.docNo] || index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* เลขใบรับ */}
                          <td className="text-center">
                            {data[fieldMappings.docNo] || "-"}
                          </td>

                          {/* สถานะ */}
                          <td className="text-center">
                            {data[fieldMappings.docStatusName] ? (
                              <button
                                className="btn"
                                style={{
                                  backgroundColor:
                                    data[fieldMappings.docStatusColour],
                                  color: "white",
                                  width: "100%",
                                }}
                              >
                                {data[fieldMappings.docStatusName]}
                              </button>
                            ) : (
                              <center>
                                <p>-</p>
                              </center>
                            )}
                          </td>

                          {/* รหัสเจ้าหนี้ */}
                          <td className="text-center">
                            {data[fieldMappings.apCode] || "-"}
                          </td>

                          {/* ชื่อเจ้าหนี้ */}
                          <td className="text-left">
                            {data[fieldMappings.apName] || "-"}
                          </td>

                          {/* จำนวนเงิน */}
                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.netTotal] || 0.0)}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}

                {/* 6.3 รายงานนำส่งรายได้ */}
                {window.location.pathname === "/vansale-report" && (
                  currentItems.length > 0 ? (
                    currentItems.map((data, index) => {
                      const rowId = data[fieldMappings.Doc_No] || index + 1;
                      return (
                        <tr
                          key={rowId}
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedRow === rowId
                                ? "rgb(105, 188, 216)"
                                : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                          onClick={() => setSelectedRow(rowId)}
                        >
                          {/* เลขใบรับ */}
                          <td className="text-center">
                            {data[fieldMappings.Doc_No] || "-"}
                          </td>

                          {/* สถานะ */}
                          <td className="text-left">
                            {data[fieldMappings.AR_Name] || "-"}
                          </td>

                          <td className="text-end">
                            {data[fieldMappings.Item_Code] === "OEM" ? data[fieldMappings.totalQty] : "-" || "-"}
                          </td>

                          <td className="text-end">
                            {data[fieldMappings.Item_Code] === "101" ? data[fieldMappings.totalQty] : "-" || "-"}
                          </td>

                          <td className="text-end">
                            {data[fieldMappings.Item_Code] === "102" ? data[fieldMappings.totalQty] : "-" || "-"}
                          </td>

                          <td className="text-end">
                            {data[fieldMappings.Item_Code] === "103" ? data[fieldMappings.totalQty] : "-" || "-"}
                          </td>

                          <td className="text-end">
                            {data[fieldMappings.Item_Code] === "105" ? data[fieldMappings.totalQty] : "-" || "-"}
                          </td>

                          {/* รหัสเจ้าหนี้ */}
                          <td className="text-end">
                            {data[fieldMappings.Total_Before_Vat] || "-"}
                          </td>

                          {/* ชื่อเจ้าหนี้ */}
                          <td className="text-end">
                            {data[fieldMappings.VAT] || "-"}
                          </td>

                          {/* จำนวนเงิน */}
                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.NetTotal] || 0.0)}
                          </td>

                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.PaymentType] === "เงินสด" ? data[fieldMappings.Pay_Total] : 0.0 || 0.0)}
                          </td>

                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.PaymentType] === "โอน" ? data[fieldMappings.Pay_Total] : 0.0 || 0.0)}
                          </td>

                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.PaymentType] === "เครดิต" ? data[fieldMappings.Pay_Total] : 0.0 || 0.0)}
                          </td>

                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.PaymentType] === "เช็ค" ? data[fieldMappings.Pay_Total] : 0.0 || 0.0)}
                          </td>

                          <td className="text-end">
                            {formatCurrency(data[fieldMappings.PaymentType] === "ค้างจ่าย" ? data[fieldMappings.Pay_Total] : 0.0 || 0.0)}
                          </td>

                          <td className="text-left">
                            {data[fieldMappings.Driver1] || "-"}
                          </td>

                          <td className="text-center">
                            {(() => {
                              const roundMapping = { 1: "เช้า", 2: "บ่าย", 3: "เย็น" };
                              return roundMapping[data[fieldMappings.PK_Round]] || "-";
                            })()}
                          </td>

                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={17}>
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <div className="row mt-3">
            <div className="col-12 d-flex justify-content-end">
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="basic-datatables_paginate"
              >
                <ul className="pagination">
                  <li
                    className={`paginate_button page-item previous ${currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <a
                      href="#"
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Previous
                    </a>
                  </li>
                  {renderPageNumbers()}
                  <li
                    className={`paginate_button page-item next ${currentPage ===
                      Math.ceil(dataMasterList.length / itemsPerPage)
                      ? "disabled"
                      : ""
                      }`}
                  >
                    <a
                      href="#"
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsTable;